import { Iteration } from 'schemas/Iteration.schema.ts';
import { CampaignConfig, IterationDetails } from 'schemas/CampaignConfig.schema.ts';

export const getIterationDefaults = (
  campaign: CampaignConfig,
  id: string,
  iterationDetails: Iteration,
): Iteration => ({
  Version: 1,
  IterationNumber: (campaign.CampaignConfig.Iterations?.length ?? 0) + 1,
  IterationCohorts: [],
  IterationRules: [],
  DefaultCommsRouting: '',
  ID: id,
  ...iterationDetails,
});

export const getIterationById = (
  campaign: CampaignConfig,
  findId: string,
): Iteration|undefined => campaign.CampaignConfig.Iterations?.find(({ ID }) => ID === findId);

export const getIterationDetailsById = (
  campaign: CampaignConfig,
  findId: string,
): IterationDetails|undefined => campaign.iteration_details?.find(({ ID }) => ID === findId);

export const hasRoutingPlanErrors = (iteration: Iteration): boolean => {
  const rules = (iteration?.IterationRules || []).filter((rule) => rule.Type === 'R' && rule.CommsRouting === '');

  return rules.length > 0;
};
